import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, OnChanges, OnDestroy, OnInit, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { AppSettings } from 'src/app/services/AppSettings';
import { FormValidation } from 'src/app/services/FormValidation';
import { GigsumoConstants } from 'src/app/services/GigsumoConstants';
import { ApiService } from 'src/app/services/api.service';
import { candidateModel } from 'src/app/services/candidateModel';
import { JobService } from 'src/app/services/job.service';
import { SlidePanelService } from 'src/app/services/slide-panel.service';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { TruncatePipe } from '../../../pipe/TruncatePipe.pipe';
import { CommonSkeletonComponent } from '../../../skeleton/common-skeleton/common-skeleton.component';
import { ConnectionTemplateComponent } from '../../../templates/connection-template/connection-template.component';
import { TimezoneDatePipe } from '../../../timezone-date.pipe';
import { JobSubmitSkillfilterComponent } from '../../../widget/job-submit-skillfilter/job-submit-skillfilter.component';
import { MessageWidgetComponent } from '../../../widget/message-widget/message-widget.component';
import { PricePlanService } from '../../Price-subscritions/priceplanService';
import { CandidatesPageComponent } from '../candidates-page/candidates-page.component';
import { DndDirective } from 'src/app/directives/dnd.directive';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';
import { CompactCountPipe } from '../../../pipe/compact-count.pipe';

import { ScrollIntentGate } from 'src/app/shared/scroll-intent-gate';
declare var $: any

@Component({
  selector: 'app-candidate-requests-received',
  standalone: true,
  imports: [
    CompactCountPipe,
    CommonModule,
    CommonSkeletonComponent,
InfiniteScrollModule,
    JobSubmitSkillfilterComponent,
    CandidatesPageComponent,
    ConnectionTemplateComponent,
    MessageWidgetComponent,
    TimezoneDatePipe,
    TruncatePipe,
    CandidatesPageComponent,
    DndDirective
  ,
    NG_ICON_DIRECTIVES,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './candidate-requests-received.component.html',
  styleUrls: ['./candidate-requests-received.component.scss'],
  inputs: ['candidateDetails', 'designVersion']
})
export class CandidateRequestsReceivedComponent extends FormValidation implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  // User-intent gate (src/app/shared/scroll-intent-gate.ts): after a page
  // lands, the next page needs a NEW physical input — a fast wheel flick's
  // smooth-scroll tail must not chain pages on its own.
  readonly scrollGate = new ScrollIntentGate({
    onArmAtBottom: () => this.onScrollDown(),
    isAtBottom: () => ScrollIntentGate.nearBottom(document.querySelector('.jc-v3-entity-details-body')),
  });

  // Subscription lifetime — cleanup hook for every `.subscribe(...)` in
  // this component (queryBlob, filter, findCandidateById,
  // updateResumeRequestStatus, findCandidatesResumeRequestedBy,
  // updateJobLiked). Parent tab re-mounts this on tab swap, so without
  // the pipe each hop leaks observables.
  private destroy$ = new Subject<void>();


  candidateId: any;
  candidateDetails: candidateModel;
  designVersion: string;
  searchConfig: any = { pageNumber: 0 }
  FormData: any;
  jobId: any;
  resumeupload;
  stopscrollFlag: boolean = false
  fileSize = AppSettings.FILE_SIZE;
  // fileDragdrop: any;
  viewedList: any = [];
  userType: string = localStorage.getItem('userType');
  connectionStatus: string;
  userId = localStorage.getItem('userId');
  object
  modalRef: BsModalRef;
  termsCheck: any;
  rtrFormData: any;
  seletedChatItem;
  messageData: any;
  messagemodelflag: any;
  candidateSupplyRef: BsModalRef;
  dataPasstoSkillwidgets: Array<any> = [];
  resumeuploaduserId: any;
  counterpartsDetails: any;
  Resurl = AppSettings.ServerUrl;
  tempFile: File;
  loadAPIcall: boolean = false;
  // Sentinel pagination: a page is requested only when the bottom sentinel
  // ENTERS view (the user scrolled it in). If it enters while a page is
  // already loading, the trigger is remembered and the observer is re-armed
  // once that page has landed (afterPageSettled), so the list never sticks
  // waiting for a scroll-up-then-down — and it never chains pages on its own
  // (no scroll listener: momentum scroll events must not count as new scrolls).
  private pendingSentinelTrigger = false;
  private afterPageSettled(): void {
    if (!this.pendingSentinelTrigger) return;
    this.pendingSentinelTrigger = false;
    setTimeout(() => this.setupScrollObserver());
  }

  @ViewChild('scrollSentinel') scrollSentinel: ElementRef;
  private intersectionObserver: IntersectionObserver | null = null;

  ngAfterViewInit(): void {
    this.setupScrollObserver();
  }

  private setupScrollObserver(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      this.intersectionObserver = null;
    }
    if (!this.scrollSentinel?.nativeElement) return;
    this.intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (!entries[0].isIntersecting) return;
        if (this.loadAPIcall) { this.pendingSentinelTrigger = true; return; }
        this.onScrollDown();
      },
      { root: null, rootMargin: '200px', threshold: 0 }
    );
    this.intersectionObserver.observe(this.scrollSentinel.nativeElement);
  }
  // Stale-response gate: bumped on every list reset (tab re-click). A fetch
  // captures the value at launch; a reset mid-flight makes the late response
  // a no-op instead of appending old rows into the cleared list.
  private fetchGeneration = 0;

  constructor(private api: ApiService, private router: Router, private modalService: BsModalService, private util: UtilService,
    private a_route: ActivatedRoute, private JobServicecolor: JobService, private planService: PricePlanService,
    private slidePanelService: SlidePanelService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges): void {
    setTimeout(() => this.setupScrollObserver());
    if (changes.candidateDetails.currentValue) {
      const newCandidateId = changes.candidateDetails.currentValue.candidateId;
      const previousCandidateId = changes.candidateDetails.previousValue?.candidateId;

      this.searchConfig.pageNumber = 0;
      this.viewedList = [];
      this.stopscrollFlag = false;
      this.candidateDetails = changes.candidateDetails.currentValue;

      // Invalidate any in-flight page fetch and unlock the loadAPIcall
      // entry guard — a tab re-click during pagination must reload fresh,
      // not skip + append the stale page into the cleared list. Duplicate
      // protection now comes from the fetchGeneration check, not from
      // keeping loadAPIcall latched.
      this.fetchGeneration++;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.afterPageSettled();

      if (this.candidateDetails.candidateId) {
        this.getResumeRequests();
      }
    }

  }
  downloadResume(candidateId, userId, createdBy, FileId, fileName?) {
    const endpoint = `candidates/resumeDownload/${candidateId}/${userId}/${createdBy}/${FileId}`;
    this.api.queryBlob(endpoint).pipe(takeUntil(this.destroy$)).subscribe(res => {
      const blob = new Blob([res]);
      // Strip backend's `<uuid>_` prefix so the saved file keeps its real
      // extension. Default to `.pdf` to avoid the OS opening it as text.
      const raw = (fileName || '').toString().trim();
      const uuidPrefix = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}_/;
      const cleaned = (uuidPrefix.test(raw) ? raw.replace(uuidPrefix, '').trim() : raw) || 'resume.pdf';
      this.downloadFile(blob, cleaned);
    });
  }

  ngOnInit() {


    this.scrollGate.attach();
    this.viewedList = [];
    this.searchConfig.pageNumber = 0;
    this.scrollSubject.pipe(
      debounceTime(100),
      takeUntil(this.destroy$)
    ).subscribe(() => {
      if (this.loadAPIcall || this.stopscrollFlag) return;
      this.getResumeRequests();
    });
  }

  // Skills chips: merge primary + secondary so the Job Secondary Skills are
  // shown too (parity with the job card's V3 Col3). Collapsed to 5 with a
  // "+N more" / "Show less" toggle via `item.showAllSkills`.
  getAllSkills(jobDetails: any): string[] {
    const primary = jobDetails?.primarySkills || [];
    const secondary = jobDetails?.secondarySkills || [];
    return [...primary, ...secondary];
  }

  toggleSkills(item: any): void {
    if (item) {
      item.showAllSkills = !item.showAllSkills;
    }
  }
  isClicked: boolean = false;
  apply(values: any, connectionTemplate?: TemplateRef<any>, candidateSupplyTemplate?: TemplateRef<any>) {
    if (this.isClicked) {
      return;
    }

    this.util.startLoader();
    this.isClicked = true;

    if (values.isFeatured == true) {
      this.proceedToApply(values, candidateSupplyTemplate);
    } else if (!values.isFeatured) {
      if (values.connectionStatus === 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);
      } else if (values.connectionStatus !== 'CONNECTED') {
        this.proceedToApply(values, candidateSupplyTemplate);

      }
    }
    setTimeout(() => {
      this.isClicked = false;
    }, 5000);
  }
  userTypeMap: { [key: string]: string } = {
    'FREELANCE_RECRUITER': 'Freelance Recruiter',
    'RECRUITER': 'Recruiter',
    'JOB_SEEKER': 'Job Seeker',
    'MANAGEMENT_TALENT_ACQUISITION': 'Manager',
    'BENCH_RECRUITER': 'Bench Recruiter'
  };


  isRoutingDisabled: boolean = false
  From: string = "JOBS_FROM_CONNECTION"

  /** V3 job-title click → job profile slider, parity with job-card's
   *  openJobInSlidePanel (job-card.component.ts:1322). The V2 branch keeps
   *  the routing `open()` below. pageFrom 'jobsApplied' = job-card's default
   *  APPLICANT_JOB ranking group for non-invited/non-suggested surfaces. */
  openJobSlider(jobData: any): void {
    if (!jobData || jobData.status === 'BLOCKED') return;
    // Candidate-side block — parity with the row's `disabled` class and with
    // the Job Invites / Applied cards (job-card.component.html:2284).
    if (this.candidateDetails?.status === 'BLOCKED') return;
    this.slidePanelService.openJobDetail(jobData, this.candidateDetails?.candidateId, {
      variant: 'v3',
      initialTab: 'profile',
      pageFrom: 'jobsApplied',
      // Resume Requests has no AI matching — hide the slider's AI Insights
      // tab and header match ring (parity with the jobs-side guard at
      // candidate-card-table-view.component.ts open()).
      hideAiInsights: true,
      // Candidate context so the slider can show the "Submitted for" rate.
      candidateData: this.candidateDetails
    });
  }

  open(values: any) {

    if (values.status != "BLOCKED") {
      if (values.clientType == null) {
        values.clientType = values.user.clientType
      }
      if (values.user != null) {
        values.clientType = values.user.clientType;
      }
      let data: any = {}
      data.jobPostedBy = values.jobPostedBy;
      data.jobId = values.jobId;
      if (values.isViewed != null && values.isViewed == true && values.jobPostedBy != this.userId) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else if (values.jobPostedBy == this.userId || localStorage.getItem('userType') == 'JOB_SEEKER') {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else if (values.isViewed) {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      } else {
        this.router.navigate(['newjobs'], { queryParams: { jobId: values.jobId, tabName: 'job-details', From: this.From } });
      }
    }
  }
  // openConnectionTemplate(connectionStatus, values, connectionTempate?: TemplateRef<any>) {
  //   this.connectionStatus = connectionStatus;
  //   this.values = values;
  //   const initialState: NgbModalOptions = {
  //     backdrop: 'static',
  //     keyboard: false,
  //     size: 'sm',
  //   };
  //   this.api.query("user/" + this.values.jobPostedBy).subscribe(res => {
  //     if (res.code == '00000') {
  //       this.counterpartsDetails = res;
  //       this.connectionRequestRef = this.modalService.show(connectionTempate, initialState);
  //     }
  //   })
  // }
  resumeData: any = []
  getchildData(data: any) {
    this.termsCheck = data.terms;
    if (data.resumes) {
      this.resumeData = data.resumes
    }
    if (data.value != null) {
      this.dataPasstoSkillwidgets = data.value;
      this.rtrFormData = data.formData;
    } else {
      this.dataPasstoSkillwidgets = [];
    }
  }
  removeUserfromTag(data) {
    this.applyResponse.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });

    this.dataPasstoSkillwidgets.forEach(element => {
      if (element.candidateId == data.candidateId) {
        element.isSelected = false;
      }
    });
  }

  closeCandidateSupplyModal() {
    this.modalService.hide(1);
  }
  async proceedToApply(values, candidateSupplyTemplate) {
    this.util.startLoader();
    this.jobDetails = values.jobDetails
    const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
    let { membershipType } = userData;
    if (userData.isExpired && this.userType != "JOB_SEEKER") {
      this.util.stopLoader();
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      userData.userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
        if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
          availablePoints = ele.available
          actualPoints = ele.actual
          utilizedPoints = ele.utilized
          promotional = ele.promotional
        }
      })
      let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

      if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
        popupType = "LIMIT";
      }
      this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      return;
    }
    this.myCandidatesForApply(values.jobDetails.jobId, candidateSupplyTemplate);
    values.clientType = values.user.clientType;
    values.userType = values.user.userType;
    let datas: any = {};
    var datacheck = [{ 'userId': localStorage.getItem('userId') }]
    datas.jobPostedBy = localStorage.getItem('userId');
    datas.jobId = values.jobDetails.jobId;
    datas.appliedBy = datacheck;
    values.jobfilter = true;
    values.filterTitle = 'Select';
    values.fromBusinessPage = false
    values.jobDescription = "";
  }
  applyResponse: any = [];
  candidateFoundStatus: string;
  jobDetails
  myCandidatesForApply(jobId: string, candidateSupplyTemplate: any) {
    const responseData: any = {
      "source": {
        "all": false,
        "myCandidates": true,
        "allPlatFormCandidates": false,
        "teamCandidates": false,
        "benchNetworkCandidates": false,
        "freeLancerNetworkCandidates": false,
        "mtaNetworkCandidates": false,
        "jobSeekerNetworkCandidates": false,
        "featured": false,
        "suggestedCandidates": false
      },
      "workType": {
        "all": false,
        "remoteWork": false,
        "relocationRequired": false,
        "workFromHome": false
      },
      "jobId": jobId,
      "workAuthorization": [],
      "engagementType": [],
      "availableIn": [],
      "status": [],
      "searchAfterKey": null,
      "city": null,
      "state": null,
      "country": null,
      "zipCode": null,
      "submissionFilters": [],
      "postedFrom": null,
      "postedTo": null,
      "limit": 10,
      "userId": this.userId,
      "searchContent": ""
    }

    this.api.create('candidates/filter', responseData).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.util.stopLoader();
      if (res.code === GigsumoConstants.SUCESSCODE) {
        this.applyResponse = res.data.candidateList;
        if (this.applyResponse.length === 0) {
          this.candidateFoundStatus = "Couldn't find any Candidates for the applied filters.";
        }
        const config: ModalOptions = { class: 'modal-lg', backdrop: 'static', keyboard: false };
        this.candidateSupplyRef = this.modalService.show(candidateSupplyTemplate, config);
      }
    });

  }

  onDownload() {
    const file: File = this.tempFile;
    this.downloadFile(new Blob([file]), file.name);
  }

  downloadFile(blob: Blob, fileName: string): void {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    // in case the Blob uses a lot of memory
    setTimeout(() => URL.revokeObjectURL(link.href), 0);
  }

  onFileDropped(files: any) {
    console.log('Files dropped:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }

  fileBrowseHandler(files: FileList) {
    console.log('Files browsed:', files);
    if (files && files.length > 0) {
      this.prepareFilesList(files);
    }
  }
  fileDragdrop: any = null;
  @ViewChild('fileDropRef') fileDropRef: ElementRef;
  prepareFilesList(files: Array<File> | FileList) {
    // Ensure we have a valid file
    if (!files || files.length === 0) {
      console.log('No files to process');
      return;
    }

    const file = files[0]; // Get the first file
    console.log('Processing file:', file);

    // Check file size
    if (file.size > this.fileSize) {
      Swal.fire("", `${this.IMAGE_ERROR}`, "info");
      if (this.fileDropRef && this.fileDropRef.nativeElement) {
        this.fileDropRef.nativeElement.value = '';
      }
      return;
    }

    // Define acceptable formats
    const acceptableFormats = [
      'application/pdf',
      'application/docx',
      'application/doc',
      'text/plain',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    console.log('File type:', file.type);

    // Check if file type is acceptable
    if (acceptableFormats.includes(file.type)) {
      // Create a more robust file object with properties your template can display
      this.fileDragdrop = {
        file: file,
        fileName: file.name,
        fileSize: this.formatBytes(file.size),
        fileType: file.type
      };
      console.log('File accepted:', this.fileDragdrop);
      this.resumeupload = file;
    } else {
      console.log('Invalid file format');
      this.fileDragdrop = null;
      this.resumeupload = null;
      Swal.fire({
        icon: "info",
        title: "Please upload a valid format.",
        showDenyButton: false,
        timer: 3000,
      });
    }
  }

  removeFiles() {
    this.fileDragdrop = null;
    this.resumeupload = null;
    if (this.fileDropRef && this.fileDropRef.nativeElement) {
      this.fileDropRef.nativeElement.value = '';
    }
  }

  // Helper function to format bytes
  formatBytes(bytes: number, decimals: number = 2): string {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }


  getCandidateDetails(candidatedata) {
    this.api.query("candidates/findCandidateById/" + candidatedata.candidateId).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (res.code == '00000') {
        this.util.stopLoader()
        this.object = res.data.candidateData;
      }
    })
  }
  closeMessage(event) {
    this.messagemodelflag = false;
  }

  chatuser(seletedItem, connectionTemplate?: TemplateRef<any>) {

    this.messagemodelflag = false;


    // this.jobDetails = seletedItem;
    if (seletedItem.isFeatured == true || (seletedItem.jobPostedBy == this.userId)) {

      this.openMessage(seletedItem);
    } else if (!seletedItem.isFeatured) {
      if (seletedItem.connectionStatus === 'CONNECTED') {
        this.openMessage(seletedItem);

      } else if (seletedItem.connectionStatus !== 'CONNECTED') {
        this.openMessage(seletedItem);

      }
    }


  }
  async openMessagecheckInteraction(seletedItem, connectionTemplate?: TemplateRef<any>) {
    // Universal first-interaction: exist-first — skip the ACTIVE_INTERACTIONS gate
    // when this job's interaction was already consumed (existing chat OR prior apply
    // — backend `alreadyConsumed`). Fails safe to gating.
    if (await this.planService.isInteractionAlreadyConsumed(seletedItem?.jobId, 'JOB')) {
      this.chatuser(seletedItem);
      return;
    }
    try {
      this.util.startLoader();
      const userData = await this.planService.UPDATE_USERDETAILS("ACTIVE_INTERACTIONS");
      let { userDetail, isExpired, membershipType } = userData;
      let availablePoints = null;
      let actualPoints = null;
      let utilizedPoints = null;
      let promotional = null;
      if (userDetail && userDetail.userPlanAndBenefits && userDetail.userPlanAndBenefits.benefitsUsages) {
        userDetail.userPlanAndBenefits.benefitsUsages.forEach(ele => {
          if (ele.benefitKey == 'ACTIVE_INTERACTIONS') {
            availablePoints = ele.available;
            actualPoints = ele.actual;
            utilizedPoints = ele.utilized;
            promotional = ele.promotional;
          }
        });
      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

        return;
      }

      if (isExpired) {
        let popupType: "PAY" | "LIMIT" | "UPGRADE" = "PAY";

        if (['Starter', 'Growth', 'ScaleX'].includes(membershipType)) {
          popupType = "LIMIT";
        }

        this.planService.expiredPopup("ACTIVE_INTERACTIONS", popupType, null, null, null, null, availablePoints, actualPoints, utilizedPoints, promotional);

      } else {
        this.util.startLoader();
        this.chatuser(seletedItem);

      }
    } catch (error) {
    } finally {
      setTimeout(() => {
        this.util.stopLoader();
      }, 1500);
    }

  }

  openMessage(seletedItem) {
    if (seletedItem.jobPostedBy == this.userId) {
      seletedItem.owner = true;
    } else {
      seletedItem.owner = false;
    }

    setTimeout(() => {
      seletedItem.userId = seletedItem.jobPostedBy;
      this.seletedChatItem = seletedItem;
      this.messageData = [];
      this.messagemodelflag = true;
      seletedItem.groupType = "JOB";
      seletedItem.messageType = "JOB";
      seletedItem.id = seletedItem.jobId;
      this.messageData = seletedItem;
    }, 1000);
  }

  submit() {

    let data: any = {};
    data.candidateId = this.candidateDetails.candidateId;
    data.userId = this.resumeuploaduserId;
    data.jobId = this.jobId;
    // data.primaryResume=true;

    if (this.resumeupload != null && this.resumeupload != '' || this.resumeupload != undefined) {
      this.FormData = new FormData();
      this.FormData.append("resume", this.resumeupload);
      this.FormData.append("candidate", new Blob([JSON.stringify(data)], { type: "application/json" }));
      this.resumeupload = "";
      this.util.startLoader()
      this.api.updatePut('candidates/updateResumeRequestStatus', this.FormData).pipe(takeUntil(this.destroy$)).subscribe(res => {
        this.modalRef.hide();
        this.util.stopLoader();
        if (res.code == '00000') {
          this.viewedList.forEach(element => {
            element.currentStatus = 'COMPLETED';
            element.fileId = "COMPLETED";
            const matchedLog = res.data.candidateData.resumeRequestLogs.find(log => log.jobId === element.jobDetails.jobId);
            if (matchedLog) {
              element.activityDate = matchedLog.date;
            } else {
              element.activityDate = null; // or some default value
            }
          });
        }
      })
    } else {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "Please select file",
        showConfirmButton: false,
        timer: 1500,
      })
    }
  }


  model(items, template: TemplateRef<any>) {
    this.resumeupload = null;
    this.object = null;

    this.resumeuploaduserId = items.user.userId;
    if (items.jobDetails != null) {
      this.jobId = items.jobDetails.jobId;
    }

    this.fileDragdrop = null;
    this.modalRef = this.modalService.show(template, { backdrop: "static", animated: true });
  }

  // Status pill (V3 col4, top-right) — derived from `fileId`, the same field
  // the Attach Resume / Attached buttons key off, so the pill and button can
  // never disagree. Mirrors the job-side Resume Requests vocabulary
  // (candidate-card-table-view.getResumeRequestStatusLabel): no resume yet →
  // amber "Resume Pending", attached → green "Resume Attached".
  resumeRequestPillLabel(items: any): string {
    return items?.fileId != null ? 'Resume Attached' : 'Resume Pending';
  }

  resumeRequestPillStyle(items: any) {
    return this.getStyle(items?.fileId != null ? 'ACCEPTED' : 'RESUME-PENDING');
  }

  getInitialstwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getInitialsparam(firstname, lastname);
  }

  getColortwo(firstname: string, lastname: string): string {
    return this.JobServicecolor.getColorparam(firstname, lastname);
  }
  getTextColor(firstname: string, lastname: string): string {
    return this.JobServicecolor.getTextColor(firstname, lastname);
  }
  emptymessage: boolean = false
  getResumeRequests() {
    // Prevent duplicate API calls on rapid clicks (e.g., double-click)
    if (this.loadAPIcall) {
      return;
    }
    const reqCandidateId = this.candidateDetails?.candidateId;
    this.searchConfig.candidateId = reqCandidateId;
    this.searchConfig.limit = 10;
    // this.util.startLoader();
    this.loadAPIcall = true;
    const gen = this.fetchGeneration;

    this.api.create('candidates/findCandidatesResumeRequestedBy', this.searchConfig).pipe(takeUntil(this.destroy$)).subscribe(res => {
      if (gen !== this.fetchGeneration) return;
      if (reqCandidateId !== this.candidateDetails?.candidateId) return;
      this.loadAPIcall = false; this.scrollGate.pageLanded();
      this.afterPageSettled();
      if (res.code === '00000' && res.data && res.data.resumeRequestedByList) {
        // this.util.stopLoader();
        const newItems = res.data.resumeRequestedByList
        //.filter(ele => {  return !this.viewedList.some(item => item.jobId === ele.jobId); });  // duplicate check

        // Add new items to the viewedList
        newItems.forEach(ele => {
          ele.photo = null;
          if (ele.user && ele.user.photo != null) {
            ele.photo = AppSettings.photoUrl + ele.user.photo;
          }
          this.viewedList.push(ele); 
         });

        // Remove duplicates from viewedList
        // this.viewedList = this.viewedList.filter((item, index, self) =>
        //   index === self.findIndex((t) => (
        //     t.jobDetails.jobId === item.jobDetails.jobId && t.user.userId === item.user.userId
        //   ))
        // );


        if (res.data.resumeRequestedByList.length === 0) {
          this.stopscrollFlag = true;
        } else if (res.data.resumeRequestedByList.length < 9) {
          this.stopscrollFlag = true;
        } else {
          this.searchConfig.pageNumber = this.searchConfig.pageNumber + 1;
          this.stopscrollFlag = false;
        }
      } else if (res.code === '00000' && res.data == null) {
        this.loadAPIcall = false; this.scrollGate.pageLanded();
        this.afterPageSettled();
        this.emptymessage = true
      }
    }, () => {
      // Network/HTTP error: clear the loading flag, otherwise every later
      // scroll trigger is dropped and the tab never paginates again.
      if (gen === this.fetchGeneration) { this.loadAPIcall = false; this.scrollGate.pageLanded(); }
    });
  }
  like(jobDetails: any) {
    if (jobDetails.jobPostedBy != localStorage.getItem('userId')) {
      if (jobDetails.isProcessingLike) {
        return;
      }

      jobDetails.isProcessingLike = true;

      let datas: any = {};
      if (jobDetails.isLiked == false || jobDetails.isLiked == null) {
        datas.likeStatus = "LIKE";
      } else if (jobDetails.isLiked == true) {
        datas.likeStatus = "UNLIKE";
      }
      datas.userId = localStorage.getItem('userId');
      datas.jobId = jobDetails.jobId;

      this.api.updatePut("jobs/updateJobLiked", datas).pipe(takeUntil(this.destroy$)).subscribe((res) => {
        jobDetails.likesCount = res.data.jobData.likesCount; // Update likesCount immediately
        jobDetails.isLiked = res.data.jobData.isLiked;
        jobDetails.isProcessingLike = false; // Re-enable the like button
        this.util.stopLoader();
      }, err => {
        jobDetails.isProcessingLike = false; // Re-enable the like button in case of error
        this.util.stopLoader();
      });

    }
  }
  scrollSubject = new Subject<void>();
  onScrollDown() {
    if (!this.loadAPIcall && !this.stopscrollFlag && this.scrollGate.armed) {
      this.scrollSubject.next();
    }
  }

  // Cleanup all tracked subscriptions on tab swap / destroy.
  ngOnDestroy(): void {

    this.scrollGate.detach();
    this.intersectionObserver?.disconnect();
    this.destroy$.next();
    this.destroy$.complete();
  }

}
